import { CommonModule, Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatIconButton } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { map } from 'rxjs';

@Component({
  selector: 'app-toolbar',
  standalone: true,
  imports: [
    CommonModule,
    MatIconButton,
    MatIcon,
    RouterModule,
    MatDividerModule
  ],
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarComponent {
  private _route = inject(ActivatedRoute);
  private _router = inject(Router);
  private param = toSignal(this._route.queryParams);
  private paramsMap = toSignal(this._route.queryParamMap);
  private _location = inject(Location)

  rootPath = input<string>('/../..');

  showBack = toSignal(
    this._route.url.pipe(
      map(segments => segments.some(url => url.path))
    )
  )

  goBack(): void {
    const currentUrl = this._router.url;
    const segment = currentUrl.split('/').filter(segment => segment != '');
    const generalTabId = this.paramsMap()?.get('generalTabId');
    const resolutionAndMitigationPlanId = this.paramsMap()?.get('resolutionAndMitigationPlanId');
    if (!segment)
      return;

    if (segment[1] === 'action-items') {
      this._router.navigate(['reports', generalTabId], { queryParams: { step: 'mitigation-and-resolution-plan' } });
    } else {
      this._router.navigate([this.rootPath()]);
    }

    // this._location.back();

  }
}
